module.exports = __webpack_public_path__ + "img/mapCamera2.0385f62a.png";